import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Overview from "@/pages/Overview";
import Servers from "@/pages/Servers";
import Console from "@/pages/Console";
import DiscordPage from "@/pages/DiscordPage";
import AuditLogs from "@/pages/AuditLogs";
import Settings from "@/pages/Settings";
import Analytics from "@/pages/Analytics";
import Players from "@/pages/Players";
import Moderation from "@/pages/Moderation";
import Economy from "@/pages/Economy";
import System from "@/pages/System";
import PlayerPortal from "@/pages/PlayerPortal";
import Feeds from "@/pages/Feeds";
import BattlePass from "@/pages/BattlePass";
import Casino from "@/pages/Casino";
import Tickets from "@/pages/Tickets";
import DiscordTools from "@/pages/DiscordTools";
import Punishments from "@/pages/Punishments";
import Engagement from "@/pages/Engagement";
import Protection from "@/pages/Protection";
import { Kits, Shop } from "@/pages/Store";
import { Events, Rules, Teleports } from "@/pages/Gameplay";
import Setup from "@/pages/Setup";
import Browse from "@/pages/Browse";
import Docs from "@/pages/Docs";
import Legal from "@/pages/Legal";
import Home from "@/pages/Home";
import ServerPublic from "@/pages/ServerPublic";
import ServerTools from "@/pages/ServerTools";

const PortalRoute = ({ page = <PlayerPortal />, path = "/portal" }) => {
  const { session } = useAuth();
  if (session === null) return null;
  if (!session) { localStorage.setItem("ranger.returnTo", path); return <Navigate to="/login" replace />; }
  const back = localStorage.getItem("ranger.returnTo");
  if (back && back !== path) { localStorage.removeItem("ranger.returnTo"); return <Navigate to={back} replace />; }
  localStorage.removeItem("ranger.returnTo");
  return page;
};

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/s/:id" element={<ServerPublic />} />
            <Route path="/privacy" element={<Legal doc="privacy" />} />
            <Route path="/terms" element={<Legal doc="terms" />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/portal" element={<PortalRoute />} />
            <Route path="/setup" element={<PortalRoute page={<Setup />} path="/setup" />} />
            <Route element={<AppShell />}>
              <Route path="/overview" element={<Overview />} />
              <Route path="/servers" element={<Servers />} />
              <Route path="/server-tools" element={<ServerTools />} />
              <Route path="/console" element={<Console />} />
              <Route path="/discord" element={<DiscordPage />} />
              <Route path="/audit" element={<AuditLogs />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/players" element={<Players />} />
              <Route path="/moderation" element={<Moderation />} />
              <Route path="/feeds" element={<Feeds />} />
              <Route path="/battlepass" element={<BattlePass />} />
              <Route path="/casino" element={<Casino />} />
              <Route path="/tickets" element={<Tickets />} />
              <Route path="/discord-tools" element={<DiscordTools />} />
              <Route path="/punishments" element={<Punishments />} />
              <Route path="/engagement" element={<Engagement />} />
              <Route path="/protection" element={<Protection />} />
              <Route path="/economy" element={<Economy />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/kits" element={<Kits />} />
              <Route path="/teleports" element={<Teleports />} />
              <Route path="/events" element={<Events />} />
              <Route path="/rules" element={<Rules />} />
              <Route path="/system" element={<System />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
